import { inject, Injectable } from '@angular/core';

import { LocalStorageService } from '@iss/wo-common/local-storage';

@Injectable()
export class UserContextService {
  private readonly localStorage = inject(LocalStorageService);

  public open(): void {
    this.localStorage.clearVolatileValues();
    window.location.href = '/app-context';
  }

  public close(url = '/'): void {
    window.location.href = url;
  }
}
